import { FC } from 'react';
import { Box, makeStyles } from '@material-ui/core';

interface BadgeProps {
  label: string;
  backgroundColor: string;
  textColor: string;
  dotColor: string;
}

const useStyles = makeStyles(() => ({
  container: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 4,
    borderRadius: 16,
    padding: '4px 8px',
    minWidth: 'fit-content'
  },
  dot: {
    width: 8,
    height: 8,
    borderRadius: 4,
    flexShrink: 0
  },
  label: {
    fontFamily: 'Roboto, sans-serif',
    fontWeight: 600,
    fontSize: 12,
    lineHeight: '16px',
    whiteSpace: 'nowrap'
  }
}));

/**
 * Badge Component
 * A reusable badge with a colored dot indicator and label
 * Used for displaying status, categories, or any labeled information with color coding
 */
export const Badge: FC<BadgeProps> = ({
  label,
  backgroundColor,
  textColor,
  dotColor
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.container} style={{ backgroundColor }}>
      <Box className={classes.dot} style={{ backgroundColor: dotColor }} />
      <span className={classes.label} style={{ color: textColor }}>
        {label}
      </span>
    </Box>
  );
};
